import styles from './styles.module.scss';
import { Count as CroplerCount } from '@cropler/ui-kit';

const SidebarHeader = ({ title, text, count, children }) => {
  return (
    <div className={styles.sidebarHeader}>
      <div className={styles.sidebarHeaderBody}>
        {title && (
          <h2 className={styles.sidebarTitle}>
            {title}
            {!!count && <CroplerCount>{count}</CroplerCount>}
          </h2>
        )}
        {text && <p className="text-muted">{text}</p>}
      </div>
      {children}
    </div>
  );
};

export default SidebarHeader;
